import React, { useState } from 'react';
import { Form, Layout, Menu, Card, Typography, Radio} from 'antd';
import {Link, useLocation} from 'react-router-dom';
import { UploadOutlined } from '@ant-design/icons';
import AdminForm from './Add_Admin/Add_Admin.js';
import CustomerForm from './Add_Customer/Add_Customer_Page.js'

import Sidebar from '../Side_Bar/Admin_Side_Bar.js';

const { Sider} = Layout;
const { Title } = Typography;

const Add_User = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [userType, setUserType] = useState('customer'); // Default to 'customer'
  const [collapsed, setCollapsed] = useState(false);

  const handleUserTypeChange = (value) => {
    setUserType(value);
  };

  return (
      <Layout style={{ minHeight: '98vh' }}>
        <Sidebar location={location} />
      <Layout style={{ background: 'white'}}>
        <div style={{ maxWidth: '100%', margin: '20px', textAlign: 'center', fontFamily: 'Helvetica, Arial, sans-serif' }}>
          <Title level={2} style={{marginTop: "0px", margin: "20px", fontWeight: "bold", textAlign: "left"}}>CREATE FAR-TECH ADMIN</Title>
            <AdminForm /> 
        </div>
      </Layout>
    </Layout>
  
  );
};  

export default Add_User;
